// seconds * minutes * hours * days
export const COOKIE_EXPIRATION_TIME = 60 * 60 * 24; // 1 day
export const TOKEN_COOKIE = 'bb.token';
export const REFRESH_TOKEN_COOKIE = 'bb.refreshToken';
export const BADGES_STORAGE_KEY = 'bb.badges';
export const VERSION = 'v1.4.32';

export function getNameSetor(array: any) {
  if (!array) return
  if (array.includes('DUsiDx7')) {
    return 'Gestor de Ideias'
  }
  if (array.includes('DRjWqyD')) {
    return 'Agente de Tecnologia';
  }
  if (array.includes('DRj0IUB')) {
    return 'Agente Comercial'
  }
  return "--"
}

export function isGestor(array: any) {
  return array.includes('DUsiDx7');
}